import Reflux from 'reflux';

export default Reflux.createActions(['activatePanel', 'togglePanel', 'hidePanel']);
